import { render, staticRenderFns } from "./GoodsAnalysis.vue?vue&type=template&id=53681a04&scoped=true"
import script from "./GoodsAnalysis.vue?vue&type=script&lang=js"
export * from "./GoodsAnalysis.vue?vue&type=script&lang=js"
import style0 from "./GoodsAnalysis.vue?vue&type=style&index=0&id=53681a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53681a04",
  null
  
)

export default component.exports